module.exports = __webpack_public_path__ + "static/media/tools.d1d066c9.png";